import { render } from "./SectionLine.vue?vue&type=template&id=4e435cf2"
import script from "./SectionLine.vue?vue&type=script&lang=js"
export * from "./SectionLine.vue?vue&type=script&lang=js"
script.render = render

export default script